import React from 'react'
import PropTypes from "prop-types"
import { FormGroup, ControlLabel, Modal } from 'react-bootstrap'
import moment from 'moment'
import { has } from 'lodash'
import { DateTimePicker } from 'react-widgets'

import { str2date, date2str } from '../../../lib/Tools'
import Button from '../../components/Button.jsx'
import { getText } from '../../lib/text.js'
import { addException, timetablePropType } from '../timetable'

import "./timetableEditor.less"

export default class AddExceptionModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { date: moment().format("YYYY/MM/DD") }
  }

  checkDate() {
    this.setState({ dateExists: has(this.props.timetable, ['exceptions', this.state.date]) })
  }

  componentDidMount() {
    this.checkDate()
  }

  componentDidUpdate(_prevProps, prevState) {
    if (this.state.date != prevState.date) {
      this.checkDate()
    }
  }

  props: {
    timetable: timetablePropType.isRequired,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  render() {
    const { timetable, onClose, onChange } = this.props

    return (
      <Modal show onHide={() => this.props.onClose()} className="add-exception-modal">
        <Modal.Header>{getText(`Añadir excepcion`)}</Modal.Header>
        <Modal.Body>
          <div>
            <FormGroup>
              <ControlLabel>{getText("Elegir dia")}:</ControlLabel>
              <DateTimePicker
                calendar
                time={false}
                format="LL"
                editFormat="YYYY/MM/DD"
                value={this.state.date ? str2date(this.state.date) : null}
                onChange={d => this.setState({ date: date2str(d) })}
              />
            </FormGroup>
            {
              this.state.dateExists && (
                <div className="error">
                  ❌ Ya existe una excepcion con esta fecha
                </div>
              )
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => onClose()}>
            {getText("Cancelar")}
          </Button>
          <Button
            disabled={!this.state.date || this.state.dateExists}
            bsStyle="success"
            onClick={() => onChange(addException(timetable, this.state.date))}
            label={getText("Añadir")}
          />
        </Modal.Footer>
      </Modal>
    )
  }
}
